module.exports = __webpack_public_path__ + "static/img/search.8b49baae.svg";